import { useCallback } from 'react';
import styled from '@emotion/styled';
import { ButtonSet } from '@trinity/chat-components/components/Modal/ButtonSet.js';
import type { ModalProps } from '@trinity/chat-components/components/Modal/Modal.js';
import Prompt from '@trinity/chat-components/components/Modal/Prompt.js';
import Button from '@trinity/chat-components/components/presentation/Button/index.js';
import { useDeleteFolderMutation } from '@/containers/Workspace.Folder/hooks/useDeleteFolder';

type Props = {
  folderId: number;
  workspaceId: number;
} & Pick<ModalProps, 'open' | 'onClose'>;

export const DeleteFolderPrompt = ({
  folderId,
  workspaceId,
  onClose,
  open,
}: Props) => {

  const mutation = useDeleteFolderMutation();

  const handleSave = useCallback(() => {
    return mutation.mutateAsync({
      folderId,
      workspaceId,
    }, {
      onSuccess: () => {
        onClose();
      },
    });
  }, [folderId, mutation, onClose, workspaceId]);

  const Footer = useCallback(() => {
    return (
      <ButtonSet>
        <StyledButton
          disabled={mutation.isPending}
          color="destructive"
          onClick={onClose}
          variant="brick">
          Cancel
        </StyledButton>
        <StyledButton
          disabled={mutation.isPending}
          color="primary"
          onClick={handleSave}
          variant="brick">
          Remove
        </StyledButton>
      </ButtonSet>
    );
  }, [handleSave, mutation.isPending, onClose]);

  return (
    <Prompt
      body="Are you sure you want to remove this folder?"
      footer={Footer()}
      header="Remove Folder"
      onClose={onClose}
      visible={open} />
  );
};

const StyledButton = styled(Button)({
  minWidth: 130,
});